import { useSelector } from 'react-redux';

export const useCardView = () => {
	const { productCardView } = useSelector((state) => state);

	return {
		isListView: productCardView === 'list',
		isGridView: productCardView === 'grid',
	};
};

export default useCardView;
